import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import {
    AI_GRADIENT_GREEN_BLUE,
    WHITE_LINEAR_GRADIENT,
} from "app/pages/sales-intelligence/modules/ai-agent/components/styles";

export const StyledSuggestion = styled.div`
    box-sizing: border-box;
    width: fit-content;
    height: 100%;
    min-height: 32px;
    ${setFontVariant("report", colorsPalettes.carbon[300])};
    padding: 6px 12px;
    margin: 0;
    border-radius: 25px;
    border: 1px solid ${colorsPalettes.carbon[50]};
    box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
    background-color: ${colorsPalettes.carbon[0]};
    cursor: pointer;

    &:hover {
        color: ${colorsPalettes.carbon[500]};
        border: 1px solid transparent;
        background-origin: border-box;
        background-clip: padding-box, border-box;
        background-image: ${WHITE_LINEAR_GRADIENT}, ${AI_GRADIENT_GREEN_BLUE};
    }
`;
